// extracted by mini-css-extract-plugin
export default {"modal":"_1Saox","pageResetPassword":"_3br05","close":"N0WFh","closeIcon":"_1kX8o"};